import styled from "@emotion/styled"

const AboutContainerStyle = styled('div')(() => ({
    width: '100%',
    height:'800px',
    display: 'flex',
    paddingTop:'60px',
    justifyContent:'center',
    justifyContent:'space-around',
    borderRadius: '10px',
}))

export default AboutContainerStyle